import { auth } from "../firebase/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./landing-page.scss";
// import Logo from "../../images/academates-logo.png";
import Logo from "../../images/nav-logo.png";
import { IsAuthContext } from "../../../App";
import SideBarImage from "../../images/side-bar-image.png";
import ForumPageImage from "../../images/forum-page-image.png";
import ChatRoomImage from "../../images/chat-room-image.png";
// import BottomContentImage from "../../images/bottom-content-image.png";

export const Landingpage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState();
  const navigate = useNavigate();

  const contextValues = useContext(IsAuthContext);
  const [isAuthenticated, setIsAuthenticated, , setUserData] = contextValues;

  // const [userData, setUserData, isAuthenticated] = useContext(IsAuthContext);

  const signIn = async (event) => {
    event.preventDefault();

    try {
      const signedIn = await signInWithEmailAndPassword(auth, email, password);

      if (signedIn) {
        setUserData(email);
        setIsAuthenticated(true);
      }
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        alert("User not found");
      } else if (email === "" || password === "") {
        alert("Please fill all fields.");
      } else if (err.code === "auth/wrong-password") {
        alert("The password you have entered is wrong");
      } else if (err.code === "auth/invalid-email") {
        alert("Please enter a valid email.");
      } else {
        alert("There was an error with your request");
      }
    }
  };

  const handleNavigate = () => {
    navigate("/create-account");
  };
  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/home");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="landing-page">
      <nav>
        <div className="left-nav-container">
          <img src={Logo} alt="Logo" />
          <span>Academates</span>
        </div>
        <div className="right-nav-container">
          <a href="mailto: infoacademates@gmail.com">Contact</a>
          <span onClick={handleNavigate}>Sign Up</span>
        </div>
      </nav>
      <div className="landing-content-container">
        <div className="landing-content">
          <h1>
            Connect <span style={{ color: "#ff5823" }}>.</span> Learn{" "}
            <span style={{ color: "#ff5823" }}>.</span> Excel
          </h1>
          <p>
            Join our completely <span style={{ color: "#ff5823" }}>FREE</span>{" "}
            forums and find answers to all your questions in various subjects
            including Math, Physics, Chemistry, and more.
            {/* <span style={{ fontSize: "2rem" }}>🚀</span> */}
          </p>
        </div>
        <form className="landing-page-form-container">
          <h2>Sign in to Continue</h2>
          <div className="inputs-container">
            <input
              placeholder="Email..."
              maxLength={35}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autocomplete="username"
            />
            <input
              placeholder="Password..."
              type="password"
              maxLength={15}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <button type="submit" onClick={signIn}>
            Sign In
          </button>
          <div className="options-container">
            <span onClick={handleForgotPassword}>Forgot Password</span>
            <span onClick={handleNavigate}>Create an Account</span>
          </div>
        </form>
      </div>
      <div className="about-container">
        <div className="about-container-title">What's Academates?</div>
        <div className="three-info-container">
          <div className="info-container">
            <h2>Subject Specific Help</h2>
            <h3>📚</h3>
            <p>
              Engage in subject specific forums to get homework help, ask
              questions, and collaborate with peers
            </p>
          </div>
          <div className="info-container">
            <h2>Live Chat Assistance</h2>
            <h3>💬</h3>
            <p>
              Click into posts to enter live chatrooms for real-time assistance
              and get immediate help from others
            </p>
          </div>
          <div className="info-container">
            <h2>Safe Environment</h2>
            <h3>🤝</h3>
            <p>
              Join a supportive community focused on mutual help and meaningful
              conversations
            </p>
          </div>
        </div>
      </div>
      <div className="additional-info-container">
        <div className="additional-info-images-container">
          <img src={SideBarImage} className="side-bar-image" alt="side-bar" />
          <img
            src={ForumPageImage}
            className="forum-page-image"
            alt="forum-page"
          />
          <img
            src={ChatRoomImage}
            className="chat-room-image"
            alt="chat-room"
          />
        </div>
        <div className="additional-info-text">
          <h2>Interactive Forums for Student Support</h2>
          <p>
            Dive into dedicated forums tailored to each subject. Engage in
            discussions, ask questions, and benefit from a community of
            like-minded students.
          </p>
        </div>
      </div>
      <div className="bottom-content-container">
        <div className="bottom-content">
          <h2>
            Join Academates now and discover a vibrant hub of learning where
            support, knowledge, and growth intertwine. Start your journey to
            academic success today.
          </h2>
          <button onClick={handleNavigate}>Join Now!</button>
        </div>
        {/* <img
          alt="logo"
          src={BottomContentImage}
          className="bottom-content-logo"
        /> */}
      </div>
    </div>
  );
};
export default Landingpage;
